export default __webpack_public_path__ + "static/media/ps.1d76b77b.svg";